export default __webpack_public_path__ + "static/media/markets-large.06110770.svg";